import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får jag bjuda gäster på alkohol som marknadsföring?";
const SHORT_ANSWER = "Nej, generellt inte. Fri alkohol till allmänheten som lockmedel är inte förenligt med kraven på måttfullhet i 7 kap. alkohollagen.";

export const Route = createFileRoute("/fraga/far-jag-erbjuda-fri-alkohol-som-kampanj")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får jag bjuda gäster på alkohol som marknadsföring" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Det finns smala undantag – t.ex. provsmakning enligt tillstånd, smakprov i samband med matprovning. Som öppen 'reklamkampanj' fungerar det inte."}
      source={{ label: "Konsumentverket – Marknadsföring av alkohol", href: "https://www.konsumentverket.se/for-foretag/marknadsforing/marknadsforing-av-alkohol/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Marknadsföring och fri alkohol" }}
      related={[{"to": "/fraga/vad-galler-for-prissattning", "label": "Får jag sänka alkoholpriserna hur mycket jag vill?"}, {"to": "/fraga/far-jag-anvanda-personalrabatt", "label": "Får personalen få alkohol gratis eller till rabatt?"}, {"to": "/fraga/far-jag-marknadsfora-alkohol-i-sociala-medier", "label": "Får jag marknadsföra alkohol på sociala medier?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får jag bjuda gäster på alkohol som marknadsföring?" },
      { name: "description", content: "Nej, generellt inte. Fri alkohol till allmänheten som lockmedel är inte förenligt med kraven på måttfullhet i 7 kap. alkohollagen." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-jag-erbjuda-fri-alkohol-som-kampanj" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-jag-erbjuda-fri-alkohol-som-kampanj" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-jag-erbjuda-fri-alkohol-som-kampanj",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får jag bjuda gäster på alkohol som marknadsföring", url: "https://alkoholprovet.se/fraga/far-jag-erbjuda-fri-alkohol-som-kampanj" },
      ]),
    ],
  }),
});
